const pushGTMEvent = (evName, value) => {
  if (typeof window !== "undefined" && window.dataLayer) {
    document.cookie = `${evName}=${value}; path=/;`
    window.dataLayer.push({ event: evName })
  }
}

export default pushGTMEvent
